import { db } from "../index";

const fieldToString = {
  folders: "Dossier",
  booking: "Réservation",
  CityTariffs: "Tarif",
  company: "Entreprise",
  customer: "Client/Passager",
  driver: "Chauffeur",
  events: "Evénement",
  provider: "Client",
  vehicle: "Véhicule",
  estimates: "Devis",
  invoices: "Facture",
};

const fieldToUrlPart = {
  folders: "folders",
  booking: "bookings",
  CityTariffs: "price",
  company: "company",
  customer: "customer",
  driver: "driver",
  events: "events",
  provider: "provider",
  vehicle: "vehicle",
  estimates: "estimates",
  invoices: "invoices",
};

const fieldToReadable = [
  { readable: "Dossier", match: /folders?/g },
  { readable: "Réservation", match: /bookings?/g },
  { readable: "Téléphone", match: /[^\s]*phone[^\s]*/g },
  { readable: "Téléphone", match: /tel/g },
  { readable: "Email", match: /email/g },
  { readable: "Nom", match: /lastname/g },
  { readable: "Prénom", match: /firstname/g },
  { readable: "Nom", match: /name/g },
  { readable: "Entreprise", match: /entreprise/g },
  { readable: "Entreprise", match: /company/g },
  { readable: "Compagnie", match: /company/g },
  { readable: "Chauffeur", match: /driver/g },
  { readable: "Client", match: /provider/g },
  { readable: "Véhicule", match: /vehicle/g },
  { readable: "Devis", match: /estimates?/g },
  { readable: "Facture", match: /invoices?/g },
  { readable: "Tarif", match: /CityTariffs?/g },
  { readable: "Evénement", match: /events?/g },
  { readable: "Passager", match: /customer/g },
  { readable: "Adresse", match: /address/g },
  { readable: "Adresse complète", match: /full_address/g },
  { readable: "Informations", match: /instruction/g },
  { readable: "Code de référence", match: /ref_code/g },
  { readable: "Numéro de vol", match: /flight_number/g },
  { readable: "Nombre de passagers", match: /passengers?/g },
  { readable: "Nombre de bagages", match: /bags?/g },
  { readable: "Date", match: /date/g },
  { readable: "Heure", match: /time/g },
  { readable: "Distance", match: /distance/g },
  { readable: "Durée", match: /duration/g },
  { readable: "ID", match: /id/g },
  { readable: "Clé", match: /key/g },
  { readable: "Numéro de macaron", match: /macaron_number/g },
  { readable: "Contact", match: /contacts?/g },
  { readable: "Destination", match: /[^\s]*dropoff[^\s]*/g },
  { readable: "Départ", match: /[^\s]*pickup[^\s]*/g },
  { readable: "Ville", match: /city/g },
];

function formatField(field) {
  let res = field.replaceAll(".", " > ");
  // replace the fields with readable names
  fieldToReadable.forEach(({ readable, match }) => {
    res = res.replaceAll(match, readable);
  });

  return res;
}

export function getMatchLabel(resultObj) {
  let fields = resultObj.item.fields;
  let description = resultObj.item.description;
  let match = resultObj.matches.length > 0 ? resultObj.matches[0] : null;

  if (!match) return "";

  if (match.key === "id") {
    return "ID: " + match.value;
  } else if (match.key === "title") {
    return "Titre: " + match.value;
  }

  let indices = match.indices;
  if (!indices.length) return "";
  // get the best indices based on the length of the match
  let bestMatch = indices.reduce((acc, curr) => {
    let matchLength = curr[1] - curr[0];
    let accLength = acc[1] - acc[0];
    return matchLength > accLength ? curr : acc;
  });

  let start = bestMatch[0];

  // get the number of "|" before the start of the match
  let pipeCount = 0;
  for (let i = 0; i < start; i++) {
    if (description[i] === "|") pipeCount++;
  }

  // get the field name
  let field = fields.split("|")[pipeCount];
  let fieldValue = description.split("|")[pipeCount];

  return formatField(field) + ": " + fieldValue;
}

export function concatenateProperties(obj, fieldPrefix = "", level = 0) {
  let concatenatedString = "";
  let concatenatedFields = "";

  if (level > 3 || Object.keys(obj)?.length > 50) return { fields: "", values: "" };

  for (const key in obj) {
    if (key === "id" || key === "key") continue;

    const item = obj[key];

    if (typeof item === "object" && item !== null) {
      let innerVals = concatenateProperties(
        item,
        `${fieldPrefix}${key}.`,
        level + 1
      );
      concatenatedFields += innerVals.fields;
      concatenatedString += innerVals.values;
    } else if (typeof item === "string" || typeof item === "number") {
      concatenatedString += `${item}|`;
      concatenatedFields += fieldPrefix + key + "|";
    }
  }

  return {
    fields: concatenatedFields.trim(),
    values: concatenatedString.trim(),
  };
}

export async function getObjSearchList(userInfos, dbField, getTitle) {
  let res = [];

  const snapshot = await db
    .ref("users/" + userInfos.uid + "/" + dbField)
    .once("value");

  snapshot.forEach((childSnapshot) => {
    let { fields, values } = concatenateProperties(childSnapshot.val());
    res.push({
      id: childSnapshot.key,
      title: getTitle(childSnapshot.val()),
      description: values,
      fields: fields,
      dbField: dbField,
      objType: fieldToString[dbField],
      url: `/${fieldToUrlPart[dbField]}/${childSnapshot.key}`,
    });
  });

  return res;
}
